import React from 'react';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { Style } from '../../style';
import '../welcome.scss';
import 'react-datepicker/dist/react-datepicker.css';

type orderServeType =
  | 'DEFAULT'
  | 'DINE_IN'
  | 'TAKE_OUT'
  | 'SCHEDULE_TAKE_OUT'
  | 'DELIVERY'
  | 'PICK_UP'
  | 'PAY';

function TimeSelector({
  selectedDate,
  setSelectedDate,
  selectedServeType,
  webStoreVo,
  setAvailableTimes,
  setTimeInfos,
  setSelectedTime,
  excludeDates,
  minDate,
  maxDate,
  selectedTime,
  availableTimes,
  timeInfos,
}) {
  const intl = useIntl();
  const style = new Style();
  return (
    <div className="d-flex justify-content-between">
      <div style={{ width: '50%' }}>
        <DatePicker
          className={
            selectedDate === undefined
              ? 'btn btn-lg dropdown-toggle date'
              : 'btn btn-lg dropdown-toggle date-selected'
          }
          selected={selectedDate === undefined ? null : selectedDate}
          dateFormat="MM/dd"
          onChange={(e: Date) => {
            if (e) {
              setSelectedDate(e);
              let serveType: orderServeType =
                selectedServeType === 'DELIVERY'
                  ? 'DELIVERY'
                  : 'SCHEDULE_TAKE_OUT';
              let selectedKey: string = '';
              Object.keys(
                webStoreVo.preorderTimeMap[serveType].availableTimes
              ).some((key) => {
                if (key.includes(moment(e).format('yyyy-MM-DD'))) {
                  selectedKey = key;
                  return true;
                }
                return false;
              });
              setAvailableTimes([]);
              setTimeInfos([]);
              webStoreVo.preorderTimeMap[serveType].availableTimes[
                selectedKey
              ]?.forEach((time) => {
                setAvailableTimes((availableTime) => [...availableTime, time]);
              });
              webStoreVo.preorderTimeMap[serveType].timeInfos[
                selectedKey
              ]?.forEach((info) => {
                setTimeInfos((timeInfos) => [...timeInfos, info]);
              });
              setSelectedTime(undefined);
            }
          }}
          excludeDates={excludeDates}
          minDate={minDate}
          maxDate={maxDate}
        />
      </div>
      <div style={{ width: '50%', textAlign: 'right', position: 'relative' }}>
        <button
          className="btn btn-lg time"
          style={
            selectedTime === undefined
              ? {
                  border: `1px solid ${style.getUiConfig().gray3Color}`,
                  color: `${style.getUiConfig().gray3Color}`,
                }
              : {
                  border: `1px solid ${style.getUiConfig().gray3Color}`,
                  color: `${style.getUiConfig().blackColor}`,
                }
          }
          type="button"
          data-testid="timeDropDownMenu"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {selectedDate === undefined
            ? intl.formatMessage({ id: 'welcome.selectedDate' })
            : selectedTime === undefined
            ? intl.formatMessage({ id: 'welcome.selectedTime' })
            : moment(selectedTime).format('HH:mm')}
        </button>
        <ul
          style={{ width: '100%', border: '1px solid #8D8C8C' }}
          className="dropdown-menu time-list"
          aria-labelledby="timeDropDownMenu"
        >
          {availableTimes.map((time, i) => {
            let timeInfo;
            timeInfos.some((info) => {
              if (info.time === time) {
                timeInfo = info;
                return true;
              }
            });
            let disabled: any = timeInfo?.full ? 'disabled' : undefined;
            return (
              <li key={i}>
                <button
                  className="dropdown-item btn-lg text-center"
                  style={
                    disabled
                      ? {
                          fontSize: '16px',
                          color: style.getUiConfig().gray2Color,
                        }
                      : { fontSize: '16px' }
                  }
                  disabled={disabled}
                  onClick={() => {
                    setSelectedTime(time);
                  }}
                >
                  {moment(time).format('HH:mm')}{' '}
                  {disabled ? <FormattedMessage id="error.order.full" /> : ''}
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

TimeSelector.propTypes = {};

export default TimeSelector;
